import React from 'react';

interface AgencyUnlimitedIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const AgencyUnlimitedIcon: React.FC<AgencyUnlimitedIconProps> = ({
  className,
  width = 50,
  height = 49,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_9992_39950)">
      <path
        d="M41.0899 1.30005H1.3999V40.9901H41.0899V1.30005Z"
        fill="#6F43D5"
      />
      <path
        d="M40.0202 29.43L28.3902 17.79L16.5802 29.61L11.0202 24.05L2.7002 31.96V39.76H40.0202V29.43Z"
        fill="#C5B5ED"
      />
      <path
        d="M15.6801 17.04C17.8174 17.04 19.5501 15.3074 19.5501 13.17C19.5501 11.0327 17.8174 9.30005 15.6801 9.30005C13.5427 9.30005 11.8101 11.0327 11.8101 13.17C11.8101 15.3074 13.5427 17.04 15.6801 17.04Z"
        fill="white"
        stroke="black"
        strokeWidth="2.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.3899 42.28H0.109863V0H42.3899V42.28ZM2.69986 39.69H39.7899V2.59H2.69986V39.68V39.69Z"
        fill="#080808"
      />
      <path
        d="M0.870117 33.79L11.0201 24.05L16.5801 29.61L28.3901 17.79L41.4201 30.83"
        stroke="black"
        strokeWidth="2.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M37.97 47.6401C43.6364 47.6401 48.23 43.0466 48.23 37.3801C48.23 31.7137 43.6364 27.1201 37.97 27.1201C32.3035 27.1201 27.71 31.7137 27.71 37.3801C27.71 43.0466 32.3035 47.6401 37.97 47.6401Z"
        fill="white"
      />
      <path
        d="M37.9699 48.73C31.7199 48.73 26.6299 43.64 26.6299 37.39C26.6299 31.14 31.7199 26.05 37.9699 26.05C44.2199 26.05 49.3099 31.14 49.3099 37.39C49.3099 43.64 44.2199 48.73 37.9699 48.73ZM37.9699 28.2001C32.9099 28.2001 28.7899 32.3201 28.7899 37.3801C28.7899 42.4401 32.9099 46.5601 37.9699 46.5601C43.0299 46.5601 47.1499 42.4401 47.1499 37.3801C47.1499 32.3201 43.0299 28.2001 37.9699 28.2001Z"
        fill="#080808"
      />
      <path
        d="M36.7599 41.6L32.8799 37.72L34.4099 36.19L36.7599 38.54L41.8199 33.48L43.3399 35.01L36.7599 41.6Z"
        fill="#080808"
      />
    </g>
    <defs>
      <clipPath id="clip0_9992_39950">
        <rect
          width="49.32"
          height="48.73"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default AgencyUnlimitedIcon;
